import React from 'react';
import type { F113 } from '../../../services/p1113Api';

interface Props {
  formData: Partial<F113>;
  isEditing: boolean;
  getField: (f: keyof F113) => unknown;
  setField: (f: keyof F113, v: unknown) => void;
}

/**
 * Tab4 商業代號 — ui_spec page4
 * NOTE: All validations on this page are COMMENTED OUT in FoxPro (BR-24).
 * No save validations for these fields.
 */
const Tab4CommercialCode: React.FC<Props> = React.memo(({ isEditing, getField, setField }) => {
  return (
    <div className="p1113-commercial-grid">
      <div className="p1113-field-row">
        <label>商業代號</label>
        <input
          value={String(getField('f113_411') || '')}
          onChange={e => setField('f113_411', e.target.value)}
          maxLength={6}
          disabled={!isEditing}
          className="p1113-input w-100"
        />
      </div>
      <div className="p1113-field-row">
        <label>商業名稱</label>
        <textarea
          value={String(getField('f113_412') || '')}
          onChange={e => setField('f113_412', e.target.value)}
          disabled={!isEditing}
          className="p1113-textarea"
          rows={2}
        />
      </div>
      <div className="p1113-field-row">
        <label>商業規格</label>
        <textarea
          value={String(getField('f113_413') || '')}
          onChange={e => setField('f113_413', e.target.value)}
          disabled={!isEditing}
          className="p1113-textarea"
          rows={2}
        />
      </div>
      <div className="p1113-field-row">
        <label>商業成份</label>
        <textarea
          value={String(getField('f113_414') || '')}
          onChange={e => setField('f113_414', e.target.value)}
          disabled={!isEditing}
          className="p1113-textarea"
          rows={2}
        />
      </div>
      <div className="p1113-field-row">
        <label>商業加工</label>
        <textarea
          value={String(getField('f113_415') || '')}
          onChange={e => setField('f113_415', e.target.value)}
          disabled={!isEditing}
          className="p1113-textarea"
          rows={2}
        />
      </div>
      <div className="p1113-field-row">
        <label>商業幅寬</label>
        <input
          type="number"
          value={Number(getField('f113_416')) || ''}
          onChange={e => setField('f113_416', parseFloat(e.target.value) || 0)}
          disabled={!isEditing}
          className="p1113-input w-100"
          step="0.1"
        />
      </div>
      <div className="p1113-field-row">
        <label>商業重量</label>
        <input
          type="number"
          value={Number(getField('f113_417')) || ''}
          onChange={e => setField('f113_417', parseFloat(e.target.value) || 0)}
          disabled={!isEditing}
          className="p1113-input w-100"
          step="0.1"
        />
      </div>
      <div className="p1113-field-row">
        <label>浮動範圍(起)</label>
        <input
          type="number"
          value={Number(getField('f113_418')) || ''}
          onChange={e => setField('f113_418', parseFloat(e.target.value) || 0)}
          disabled={!isEditing}
          className="p1113-input w-100"
          step="0.1"
        />
      </div>
      <div className="p1113-field-row">
        <label>浮動範圍(迄)</label>
        <input
          type="number"
          value={Number(getField('f113_419')) || ''}
          onChange={e => setField('f113_419', parseFloat(e.target.value) || 0)}
          disabled={!isEditing}
          className="p1113-input w-100"
          step="0.1"
        />
      </div>
      <div className="p1113-field-row">
        <label>商業備注</label>
        <textarea
          value={String(getField('f113_421') || '')}
          onChange={e => setField('f113_421', e.target.value)}
          disabled={!isEditing}
          className="p1113-textarea"
          rows={2}
        />
      </div>
      {/* f113_43 removed: not in field_contract, not in business_rules */}
    </div>
  );
});

Tab4CommercialCode.displayName = 'Tab4CommercialCode';
export default Tab4CommercialCode;
